import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Grid,
  Avatar,
  Chip,
} from "@mui/material";
import {
  TrendingUp,
  TrendingDown,
  LocalGasStation,
  Build,
  Payment,
  LocalShipping,
  Assessment,
  People,
  AccountBalance,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ReportFilterProvider } from "./context/ReportFilterContext";
import NavigationHeader from "../../components/NavigationHeader";
import { usePlanStatus } from "../../hooks/usePlanStatus";
import { OperationType } from "../../types/operationType";
import { useResponsiveBreakpoints } from "../../utils/responsiveUtils";

export const dailyBusReportTypes = [
  {
    id: 0,
    label: "Trip P & L",
    description: "View reports on P & L",
    icon: <Assessment />,
    type: "pnl",
    color: "#607D8B",
    shortLabel: "Trip P & L",
  },
  {
    id: 1,
    label: "Trip Ledger",
    description:
      "Comprehensive financial ledger showing trip-wise income, expenses, and profit/loss analysis",
    icon: <AccountBalance />,
    type: "ledger",
    color: "#3F51B5",
    shortLabel: "Trip Ledger",
  },
  // {
  //   id: 2,
  //   label: "Trip Income",
  //   description:
  //     "View and analyze total income from trips, bookings, and other revenue sources",
  //   icon: <TrendingUp />,
  //   type: "income",
  //   color: "#4CAF50",
  //   shortLabel: "Income",
  // },
  {
    id: 3,
    label: "Expense",
    description:
      "Track and monitor all expenses including fuel, maintenance, and other expenses",
    icon: <TrendingDown />,
    type: "expense",
    color: "#F44336",
    shortLabel: "Expense",
  },
  {
    id: 4,
    label: "Fuel Expense",
    description:
      "Monitor fuel consumption, costs, and efficiency across your fleet",
    icon: <LocalGasStation />,
    type: "fuel",
    color: "#FF9800",
    shortLabel: "Fuel Expense",
  },
  {
    id: 5,
    label: "Maintenance Expense",
    description:
      "Keep track of vehicle maintenance schedules, costs, and service history",
    icon: <Build />,
    type: "maintenance",
    color: "#9C27B0",
    shortLabel: "Maintenance Expense",
  },
  {
    id: 6,
    label: "Luggage Commission",
    description:
      "Analyze commission earnings from luggage handling and transportation services",
    icon: <Payment />,
    type: "commission",
    color: "#2196F3",
    shortLabel: "Luggage Commission",
  },
  {
    id: 7,
    label: "Pickup Man Luggage",
    description:
      "View reports on pickup man luggage services, frequencies, and earnings",
    icon: <LocalShipping />,
    type: "pickup",
    color: "#607D8B",
    shortLabel: "Pickup Man Luggage",
  },
  {
    id: 8,
    label: "Work Force",
    description:
      "View reports on work force services, frequencies, and earnings",
    icon: <People />,
    type: "driverCleaner",
    color: "#607D8B",
    shortLabel: "Work Force",
  },
  {
    id: 9,
    label: "Report by Vehicles",
    description: "View reports on vehicles, frequencies, and earnings",
    icon: <People />,
    type: "reportByVehicles",
    color: "#607D8B",
    shortLabel: "Report by Vehicles",
  },
];
export const contractSchoolReportTypes = [
  {
    id: 0,
    label: "Booking P & L",
    description: "View P & L for rental journeys",
    icon: <Assessment />,
    type: "rentalJourneyPnl",
    color: "#455A64",
    shortLabel: "Booking P & L",
  },

  {
    id: 11,
    label: "Booking Ledger",
    description: "View Ledger for rental journeys",
    icon: <AccountBalance />,
    type: "rentalJourneyLedger",
    color: "#455A64",
    shortLabel: "Booking Ledger",
  },
  {
    id: 2,
    label: "Expense",
    description:
      "Track and monitor all contract expenses including fuel, maintenance, and other expenses",
    icon: <TrendingDown />,
    type: "expense",
    color: "#F44336",
    shortLabel: "Expense",
  },
  {
    id: 3,
    label: "Fuel Expense",
    description:
      "Monitor fuel consumption, costs, and efficiency across your fleet",
    icon: <LocalGasStation />,
    type: "fuel",
    color: "#FF9800",
    shortLabel: "Fuel Expense",
  },
  {
    id: 4,
    label: "Maintenance Expense",
    description:
      "Keep track of vehicle maintenance schedules, costs, and service history",
    icon: <Build />,
    type: "maintenance",
    color: "#9C27B0",
    shortLabel: "Maintenance Expense",
  },
  {
    id: 5,
    label: "Work Force",
    description:
      "View reports on work force services, frequencies, and earnings",
    icon: <People />,
    type: "driverCleaner",
    color: "#607D8B",
    shortLabel: "Work Force",
  },
  {
    id: 6,
    label: "Report by Vehicles",
    description: "View reports on vehicles, frequencies, and earnings",
    icon: <People />,
    type: "reportByVehicles",
    color: "#607D8B",
    shortLabel: "Report by Vehicles",
  },
];
export const tourBookingReportTypes = [
  {
    id: 10,
    label: "Booking P & L",
    description: "View P & L for rental journeys",
    icon: <Assessment />,
    type: "rentalJourneyPnl",
    color: "#455A64",
    shortLabel: "Booking P & L",
  },
  {
    id: 11,
    label: "Booking Ledger",
    description: "View Ledger for rental journeys",
    icon: <AccountBalance />,
    type: "rentalJourneyLedger",
    color: "#455A64",
    shortLabel: "Booking Ledger",
  },
  {
    id: 3,
    label: "Expense",
    description:
      "Track and monitor all booking expenses including fuel, maintenance, and other expenses",
    icon: <TrendingDown />,
    type: "expense",
    color: "#F44336",
    shortLabel: "Expense",
  },
  {
    id: 4,
    label: "Fuel Expense",
    description:
      "Monitor fuel consumption, costs, and efficiency across your fleet",
    icon: <LocalGasStation />,
    type: "fuel",
    color: "#FF9800",
    shortLabel: "Fuel Expense",
  },
  {
    id: 5,
    label: "Maintenance Expense",
    description:
      "Keep track of vehicle maintenance schedules, costs, and service history",
    icon: <Build />,
    type: "maintenance",
    color: "#9C27B0",
    shortLabel: "Maintenance Expense",
  },
  {
    id: 6,
    label: "Work Force",
    description:
      "View reports on work force services, frequencies, and earnings",
    icon: <People />,
    type: "driverCleaner",
    color: "#607D8B",
    shortLabel: "Work Force",
  },
  {
    id: 7,
    label: "Report by Vehicles",
    description: "View reports on vehicles, frequencies, and earnings",
    icon: <People />,
    type: "reportByVehicles",
    color: "#607D8B",
    shortLabel: "Report by Vehicles",
  },
];

export const largeFleetReportTypes = [
  {
    id: 4,
    label: "Fuel Expense",
    description:
      "Monitor fuel consumption, costs, and efficiency across your fleet",
    icon: <LocalGasStation />,
    type: "fuel",
    color: "#FF9800",
    shortLabel: "Fuel Expense",
  },
  {
    id: 5,
    label: "Maintenance Expense",
    description:
      "Keep track of vehicle maintenance schedules, costs, and service history",
    icon: <Build />,
    type: "maintenance",
    color: "#9C27B0",
    shortLabel: "Maintenance Expense",
  },
  {
    id: 6,
    label: "Work Force",
    description: "View reports on WorkForce services, frequencies",
    icon: <People />,
    type: "driverCleaner",
    color: "#607D8B",
    shortLabel: "Work Force",
  },
  {
    id: 7,
    label: "Report by Vehicles",
    description: "View reports on vehicles, frequencies, and earnings",
    icon: <People />,
    type: "reportByVehicles",
    color: "#607D8B",
    shortLabel: "Report by Vehicles",
  },
];

export const uniqueReportTypes = (reportTypes: any[]) => {
  return reportTypes.filter(
    (reportType, index, self) =>
      index === self.findIndex((t) => t.type === reportType.type)
  );
};

export const allReportTypes = [
  ...dailyBusReportTypes,
  ...contractSchoolReportTypes,
  ...tourBookingReportTypes,
];

export const getFilteredReportTypes = (operationType: OperationType) => {
  if (operationType === OperationType.DAILY_BUS) {
    return dailyBusReportTypes;
  } else if (
    operationType === OperationType.SCHOOL ||
    operationType === OperationType.CONTRACT
  ) {
    return contractSchoolReportTypes;
  } else if (operationType === OperationType.LARGE_FLEET) {
    return largeFleetReportTypes;
  } else if (operationType === OperationType.TOUR_BOOKING) {
    return tourBookingReportTypes;
  } else if (
    operationType === OperationType.LARGE_FLEET_ALL ||
    operationType === OperationType.ALL
  ) {
    return uniqueReportTypes(allReportTypes)  ;
  } else {
    return dailyBusReportTypes;
  }
};

// Filter report types based on user permissions
export const getPermissionFilteredReportTypes = (
  operationType: OperationType,
  permissions: any
) => {
  const allReportTypes = getFilteredReportTypes(operationType);

  if (!permissions) {
    return [];
  }

  return allReportTypes.filter((reportType) => {
    // Direct permission checks based on report type
    switch (reportType.type) {
      case "pnl":
        return permissions?.canViewTripPNL || false;
      case "rentalJourneyPnl":
        return permissions?.canViewTripPNL || false;
      case "rentalJourneyLedger":
        return permissions?.canViewTripLedger || false;
      case "ledger":
        return permissions?.canViewTripLedger || false;
      case "income":
        return permissions?.canViewIncomeReport || false;
      case "expense":
        return permissions?.canViewExpenseReport || false;
      case "fuel":
        return permissions?.canViewFuelReport || false;
      case "maintenance":
        return permissions?.canViewMaintenanceReport || false;
      case "commission":
        return permissions?.canViewCommissionReport || false;
      case "pickup":
        return permissions?.canViewPickupReport || false;
      case "driverCleaner":
        return permissions?.canViewDriverCleanerReport || false;
      case "reportByVehicles":
        return (
          (permissions?.canViewReportByVehicles &&
            operationType !== OperationType.LARGE_FLEET &&
            operationType !== OperationType.LARGE_FLEET_ALL) ||
          false
        );
      default:
        return false;
    }
  });
};

const ReportPage: React.FC = () => {
  const navigate = useNavigate();
  const { planStatus } = usePlanStatus();
  
  // Use responsive breakpoints for layout optimization
  const {
    isMobile,
    isTablet,
    isSmallDesktop,
    getGridColumns,
    getSpacing,
    screenCategory,
  } = useResponsiveBreakpoints();

  // Get current operation type and filter modules accordingly
  const currentOperationType = planStatus.company?.operationType;
  const reportTypes = getPermissionFilteredReportTypes(
    currentOperationType,
    planStatus?.permissions
  );
  
  // Calculate responsive grid columns
  const getResponsiveColumns = () => {
    const totalItems = reportTypes.length;
    
    if (isMobile) return 12; // Full width on mobile
    if (isTablet) return 6;  // 2 columns on tablet
    if (isSmallDesktop && totalItems > 4) return 3; // 4 columns on small desktop
    return Math.max(2, Math.floor(12 / Math.min(6, totalItems))); // Dynamic sizing for larger screens
  };

  const handleCardClick = (reportType: string) => {
    navigate(`/reports/${reportType}`);
  };

  return (
    <ReportFilterProvider>
      <Container maxWidth="lg">
        <Box sx={{ py: 4 }}>
          <NavigationHeader title="Reports" backNavigationEnabled={false} />

          {reportTypes.length > 0 ? (
            <Grid container spacing={isMobile ? 2 : isTablet ? 2.5 : 3}>
              {reportTypes.map((reportType) => (
                <Grid item xs={12} sm={6} md={getResponsiveColumns()} key={reportType.id}>
                  <Card
                    sx={{
                      height: "100%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: 4,
                      },
                      cursor: "pointer",
                      minHeight: isMobile ? "120px" : isTablet ? "140px" : "160px",
                    }}
                  >
                    <CardActionArea
                      onClick={() => handleCardClick(reportType.type)}
                      sx={{ 
                        height: "100%", 
                        p: isMobile ? 0.5 : isTablet ? 0.75 : 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <CardContent 
                        sx={{ 
                          textAlign: "center", 
                          p: isMobile ? 0.5 : 1,
                          "&:last-child": { 
                            paddingBottom: isMobile ? 0.5 : 1 
                          },
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: reportType.color,
                            width: isMobile ? 32 : isTablet ? 36 : 40,
                            height: isMobile ? 32 : isTablet ? 36 : 40,
                            mx: "auto",
                            mb: isMobile ? 0.5 : 1,
                            fontSize: isMobile ? "0.875rem" : "1rem",
                          }}
                        >
                          {reportType.icon}
                        </Avatar>

                        <Typography
                          variant="subtitle2"
                          sx={{ 
                            fontWeight: "medium", 
                            fontSize: isMobile ? "0.7rem" : isTablet ? "0.72rem" : "0.75rem",
                            lineHeight: 1.2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            mb: 0.5,
                          }}
                        >
                          {reportType.label}
                        </Typography>

                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ 
                              fontSize: isTablet ? "0.6rem" : "0.65rem",
                              lineHeight: 1.2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: isTablet ? 2 : 3,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {reportType.description}
                          </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "200px",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography variant="h6" color="text.secondary">
                No Reports Available
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                You don't have permission to view any reports. Please contact
                your administrator for access.
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
    </ReportFilterProvider>
  );
};

export default ReportPage;
